<mat-card appearance="outlined" [formGroup]="configForm" class="card">
  <div class="flex-row">
    <div class="config-actions" style="flex: 0 0 15%">
      <button
        matButton="elevated"
        color="primary"
        (click)="loadConfig()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded === true"
      >
        Load config from server
      </button>
      <button
        type="submit"
        matButton="elevated"
        color="accent"
        (click)="saveConfig()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded !== true || !configForm.valid"
      >
        Save config
      </button>
      <button
        matButton="elevated"
        (click)="clearRefresh()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded === null"
      >
        Clear and Refresh
      </button>
    </div>
    <div style="flex: 1 0 60%">
      @if (configLoaded) {
        @if (!noConfigDefined) {
          <mat-accordion multi class="config-accordion">
            <mat-expansion-panel class="config-panel" [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>tune</mat-icon>
                  <span i18n>General Settings</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Due Date - Warning time [hours]:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="warning"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Due Date - Alert time [hours]:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="alert"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Order Numbering - year from:
                  </div>
                  <mat-radio-group formControlName="orderNumberDateFrom">
                    <mat-radio-button value="due_date"><span i18n>Due date</span></mat-radio-button>
                    <mat-radio-button value="created"><span i18n>Order created date</span></mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Order - allow order without devices:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.allowOrderWoDevices.value"
                    (change)="
                  configForm.controls.allowOrderWoDevices.setValue(
                    !configForm.controls.allowOrderWoDevices.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Order - department in orders:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.departmentsEnable.value"
                    (change)="
                  configForm.controls.departmentsEnable.setValue(
                    !configForm.controls.departmentsEnable.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Sequential order actions - enabled:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.sequentialActionsEnable.value"
                    (change)="
                  configForm.controls.sequentialActionsEnable.setValue(
                    !configForm.controls.sequentialActionsEnable.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Customer - enable duplicated VAT code:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.customerAllowDuplicatedVATcode.value"
                    (change)="
                  configForm.controls.customerAllowDuplicatedVATcode.setValue(
                    !configForm.controls.customerAllowDuplicatedVATcode.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable supervisor role:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.enableSupervisorRole.value"
                    (change)="
                  configForm.controls.enableSupervisorRole.setValue(
                    !configForm.controls.enableSupervisorRole.value
                  )
                "
                   />
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>apps</mat-icon>
                  <span i18n>Application</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Hide Inbox:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.menuHideRequests.value"
                    (change)="
                  configForm.controls.menuHideRequests.setValue(
                    !configForm.controls.menuHideRequests.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Hide Service Agreements:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.menuHideAgreements.value"
                    (change)="
                  configForm.controls.menuHideAgreements.setValue(
                    !configForm.controls.menuHideAgreements.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Hide Warehouses:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.menuHideWarehouses.value"
                    (change)="
                  configForm.controls.menuHideWarehouses.setValue(
                    !configForm.controls.menuHideWarehouses.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Hide Work Time:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.menuHideWorkTime.value"
                    (change)="
                  configForm.controls.menuHideWorkTime.setValue(
                    !configForm.controls.menuHideWorkTime.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Hide Products:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.menuHideProducts.value"
                    (change)="
                  configForm.controls.menuHideProducts.setValue(
                    !configForm.controls.menuHideProducts.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@configReportsEnabled">Enable Reports (admins only):</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.reportsEnabled.value"
                    (change)="
                  configForm.controls.reportsEnabled.setValue(
                    !configForm.controls.reportsEnabled.value
                  )
                "
                   />
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>smartphone</mat-icon>
                  <span i18n>Mobile Application</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Date Format [dd.MM.yyyy]:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input class="app-input" matInput formControlName="dateFormat"/>
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Time Format [HH:mm:ss]:</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input class="app-input" matInput formControlName="timeFormat"/>
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Date &amp; Time Format [dd.MM.yyyy HH:mm]:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        class="app-input"
                        matInput
                        formControlName="dateTimeFormat"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable user schedule:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.enableUserSchedule.value"
                    (change)="
                  configForm.controls.enableUserSchedule.setValue(
                    !configForm.controls.enableUserSchedule.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Status change when off work:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.statusChangeWorkOff.value"
                    (change)="
                  configForm.controls.statusChangeWorkOff.setValue(
                    !configForm.controls.statusChangeWorkOff.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Adding notes when off work:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.noteAddWorkOff.value"
                    (change)="
                  configForm.controls.noteAddWorkOff.setValue(
                    !configForm.controls.noteAddWorkOff.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Adding photos when off work:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.photoAddWorkOff.value"
                    (change)="
                  configForm.controls.photoAddWorkOff.setValue(
                    !configForm.controls.photoAddWorkOff.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Team Lead menu:</div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.teamLeadOn.value"
                    (change)="
                  configForm.controls.teamLeadOn.setValue(
                    !configForm.controls.teamLeadOn.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Adding photos from gallery:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="allowPhotoFromGallery"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Adding pdf to order:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="allowAddingPdfToOrder"
                   />
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>description</mat-icon>
                  <span i18n>Forms Settings</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Allow save as draft:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="formAllowSaveAsDraft"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Allow the new form as a copy from PDF:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="formAllowCopyFromPDF"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Font size factor for fields (on mobile dev):
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="formFieldFontFactor"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Font size factor for tables (on mobile dev):
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="formTableFontFactor"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Table in forms - max no of rows:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="formTableMaxRow"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Allow multi-language forms:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="formMultilanguageEnable"
                   />
                </div>
                @if (configForm.controls.formMultilanguageEnable.value) {
                  <div class="flex-row space-between-baseline">
                    <div class="app-details-subtitle2" i18n>
                      Default form language:
                    </div>
                    <mat-form-field
                      class="wide-field"
                      appearance="outline"
                      subscriptSizing="dynamic"
                    >
                      <mat-select formControlName="formDefaultLanguage">
                        @for (lang of allLanguages; track lang.id) {
                          @if (lang.enabled) {
                            <mat-option [value]="lang.locale">
                              {{ lang.name }} ({{ lang.locale }})
                            </mat-option>
                          }
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="app-remark" i18n>
                    Form language of customers and installations is used to show
                    the matching form versions. Installations without a language
                    use their customer's language, then this default.
                  </div>
                }
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>email</mat-icon>
                  <span i18n>Email notifications</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="app-remark" i18n>
                  Changes of the email addresses needs adjustments in the email sending
                  system. Please contact the system administrator
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Address of the email sender:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        class="app-input-text"
                        matInput
                        formControlName="formEmailAddress"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Send copy of the email to address:
                  </div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        class="app-input-text"
                        matInput
                        formControlName="formCopyEmailAddress"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Email form template id:</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        class="app-input-text"
                        matInput
                        formControlName="formEmailTemplateId"
                      />
                    </label>
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>inventory_2</mat-icon>
                  <span i18n>Warehouses</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable stock orders:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="warehouseEnableStockOrder"
                   />
                </div>
                <!-- Warehouse Release Table Config Section -->
                <div class="flex-row space-between-baseline mb-4">
                  <div class="app-details-subtitle2" i18n>Warehouse Release Table:</div>
                </div>

                <!-- Table-like form for all 4 columns -->

                <div formGroupName="warehouseReleaseTableConfig" class="warehouse-table-grid">

                  <!-- itemKey Column -->
                  <div class="warehouse-table-column" formGroupName="itemKey">
                    <div class="warehouse-table-column-title">itemKey</div>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@Key">Key</mat-label>
                      <mat-select formControlName="key" [disabled]="true">
                        <mat-option value="itemKey">itemKey</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldType">Field Type</mat-label>
                      <mat-select formControlName="formFieldType" [disabled]="true">
                        <mat-option [value]="3">3</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldName">Name</mat-label>
                      <input matInput formControlName="name"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldSort">Sort</mat-label>
                      <input matInput type="number" formControlName="sort"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldWidth">Width</mat-label>
                      <input matInput type="number" formControlName="width"/>
                    </mat-form-field>

                    <mat-checkbox formControlName="visible">
                      <span i18n="@@FieldVisible">Visible</span>
                    </mat-checkbox>
                  </div>

                  <!-- quantity Column -->
                  <div class="warehouse-table-column" formGroupName="quantity">
                    <div class="warehouse-table-column-title">quantity</div>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@Key">Key</mat-label>
                      <mat-select formControlName="key" [disabled]="true">
                        <mat-option value="quantity">quantity</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldType">Field Type</mat-label>
                      <mat-select formControlName="formFieldType" [disabled]="true">
                        <mat-option [value]="5">5</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldName">Name</mat-label>
                      <input matInput formControlName="name"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldSort">Sort</mat-label>
                      <input matInput type="number" formControlName="sort"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldWidth">Width</mat-label>
                      <input matInput type="number" formControlName="width"/>
                    </mat-form-field>

                    <mat-checkbox formControlName="visible">
                      <span i18n="@@FieldVisible">Visible</span>
                    </mat-checkbox>
                  </div>

                  <!-- name Column -->
                  <div class="warehouse-table-column" formGroupName="name">
                    <div class="warehouse-table-column-title">name</div>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@Key">Key</mat-label>
                      <mat-select formControlName="key" [disabled]="true">
                        <mat-option value="name">name</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldType">Field Type</mat-label>
                      <mat-select formControlName="formFieldType" [disabled]="true">
                        <mat-option [value]="3">3</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldName">Name</mat-label>
                      <input matInput formControlName="name"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldSort">Sort</mat-label>
                      <input matInput type="number" formControlName="sort"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldWidth">Width</mat-label>
                      <input matInput type="number" formControlName="width"/>
                    </mat-form-field>

                    <mat-checkbox formControlName="visible">
                      <span i18n="@@FieldVisible">Visible</span>
                    </mat-checkbox>
                  </div>

                  <!-- unit Column -->
                  <div class="warehouse-table-column" formGroupName="unit">
                    <div class="warehouse-table-column-title">unit</div>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@Key">Key</mat-label>
                      <mat-select formControlName="key" [disabled]="true">
                        <mat-option value="unit">unit</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldType">Field Type</mat-label>
                      <mat-select formControlName="formFieldType" [disabled]="true">
                        <mat-option [value]="3">3</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldName">Name</mat-label>
                      <input matInput formControlName="name"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldSort">Sort</mat-label>
                      <input matInput type="number" formControlName="sort"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldWidth">Width</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="width"
                        [readonly]="!configForm.get('warehouseReleaseTableConfig.unit.visible')?.value"
                        [class.warehouse-table-field-disabled]="!configForm.get('warehouseReleaseTableConfig.unit.visible')?.value"
                      />
                    </mat-form-field>

                    <mat-checkbox
                      formControlName="visible"
                      (change)="onUnitVisibilityChange($event)">
                      <span i18n="@@FieldVisible">Visible</span>
                    </mat-checkbox>
                  </div>

                  <!-- description Column -->
                  <div class="warehouse-table-column" formGroupName="description">
                    <div class="warehouse-table-column-title">description</div>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@Key">Key</mat-label>
                      <mat-select formControlName="key" [disabled]="true">
                        <mat-option value="description">description</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldType">Field Type</mat-label>
                      <mat-select formControlName="formFieldType" [disabled]="true">
                        <mat-option [value]="3">3</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldName">Name</mat-label>
                      <input matInput formControlName="name"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldSort">Sort</mat-label>
                      <input matInput type="number" formControlName="sort"/>
                    </mat-form-field>

                    <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
                      <mat-label i18n="@@FieldWidth">Width</mat-label>
                      <input
                        matInput
                        type="number"
                        formControlName="width"
                        [readonly]="!configForm.get('warehouseReleaseTableConfig.description.visible')?.value"
                        [class.warehouse-table-field-disabled]="!configForm.get('warehouseReleaseTableConfig.description.visible')?.value"
                      />
                    </mat-form-field>

                    <mat-checkbox
                      formControlName="visible"
                      (change)="onDescriptionVisibilityChange($event)">
                      <span i18n="@@FieldVisible">Visible</span>
                    </mat-checkbox>
                  </div>
                </div>

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Allow negative stock:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="warehouseAllowNegativeStock"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Material releases: hide materials with zero stock
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="warehouseNotShowZeroStock"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Additional serviceman may release materials:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="warehouseAllowAdditionalSrvm"
                   />
                </div>
                <div class="app-details-subtitle2" i18n>
                  Order statuses when material release is allowed:
                </div>
                <mat-selection-list
                  formControlName="warehouseAllowedStatuses"
                  [compareWith]="compareStatuses"
                >
                  @for (stat of statuses; track stat) {
                    <mat-list-option checkboxPosition="before" [value]="stat">
                      {{ stat.name }}
                    </mat-list-option>
                  }
                </mat-selection-list>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>account_tree</mat-icon>
                  <span i18n>Branches</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Enable branches in the Dispatcher App:
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.branchesEnable.value"
                    (change)="
                  configForm.controls.branchesEnable.setValue(
                    !configForm.controls.branchesEnable.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Branch Admin is allowed to change branch :
                  </div>
                  <mat-checkbox class="app-checkbox"
                    [checked]="configForm.controls.branchesChangeByBranchAdmin.value"
                    (change)="
                  configForm.controls.branchesChangeByBranchAdmin.setValue(
                    !configForm.controls.branchesChangeByBranchAdmin.value
                  )
                "
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>
                    Remove the team when order assigned to other branch :
                  </div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="branchesRemoveTeamFromOrder"
                   />
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>my_location</mat-icon>
                  <span i18n>Live tracking</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable live tracking:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="trackingEnable"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Live tracking in background (force permission):</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="trackingInBackground"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Live tracking - keep history (days):</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="trackingHistoryDays"
                      />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Live tracking calculate distance:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="trackingCalculateDistance"
                   />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Calculate distance - keep history (days):</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input
                        type="number"
                        class="app-input"
                        matInput
                        formControlName="trackingDistanceHistoryDays"
                      />
                    </label>
                  </mat-form-field>
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel" formGroupName="weather">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>wb_cloudy</mat-icon>
                  <span i18n="@@wxAdmTitle">Map – weather forecast</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@wxAdmEnable">Show the weather forecast on Map – planning:</div>
                  <mat-checkbox class="app-checkbox" formControlName="enabled" />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@wxAdmProvider">Weather provider:</div>
                  <div class="weather-readonly" i18n="@@wxAdmProviderValue">Google Weather API (platform setting)</div>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@wxAdmDays">Forecast days (1–7):</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input type="number" class="app-input" matInput formControlName="forecastDays" min="1" max="7" step="1" />
                    </label>
                  </mat-form-field>
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" id="weather-unit-label" i18n="@@wxAdmWindUnit">Wind unit:</div>
                  <mat-radio-group class="weather-radio" formControlName="windUnit" aria-labelledby="weather-unit-label">
                    <mat-radio-button value="ms">m/s</mat-radio-button>
                    <mat-radio-button value="kmh">km/h</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div class="app-details-subtitle2" i18n="@@wxAdmLimits">Limits (wind, rain and thunderstorms 07:00–19:00; temperature 07:00 → 07:00 next day):</div>
                <div class="weather-limits" role="group">
                  <span></span>
                  <span class="weather-limits-head caution" id="weather-col-caution" i18n="@@wxAdmCaution">Caution</span>
                  <span class="weather-limits-head stop" id="weather-col-stop" i18n="@@wxAdmStop">Stop</span>
                  <span></span>

                  <span class="weather-limits-label" id="weather-row-gust" i18n="@@wxAdmGust">Wind gusts ≥</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="gustWarn" step="0.5" aria-labelledby="weather-row-gust weather-col-caution" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="gustStop" step="0.5" aria-labelledby="weather-row-gust weather-col-stop" />
                  </mat-form-field>
                  <span class="weather-limits-unit">{{ weatherUnitLabel }}</span>

                  <span class="weather-limits-label" id="weather-row-rain" i18n="@@wxAdmRain">Precipitation ≥</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="rainWarn" step="0.5" aria-labelledby="weather-row-rain weather-col-caution" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="rainStop" step="0.5" aria-labelledby="weather-row-rain weather-col-stop" />
                  </mat-form-field>
                  <span class="weather-limits-unit">mm</span>

                  <span class="weather-limits-label" id="weather-row-low" i18n="@@wxAdmLow">Day's low ≤</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="tempLowWarn" step="1" aria-labelledby="weather-row-low weather-col-caution" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="tempLowStop" step="1" aria-labelledby="weather-row-low weather-col-stop" />
                  </mat-form-field>
                  <span class="weather-limits-unit">°C</span>

                  <span class="weather-limits-label" id="weather-row-high" i18n="@@wxAdmHigh">Day's high ≥</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="tempHighWarn" step="1" aria-labelledby="weather-row-high weather-col-caution" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input type="number" class="app-input" matInput formControlName="tempHighStop" step="1" aria-labelledby="weather-row-high weather-col-stop" />
                  </mat-form-field>
                  <span class="weather-limits-unit">°C</span>
                </div>
                @if (configForm.controls.weather.errors; as errors) {
                  <div class="weather-errors" role="alert">
                    @if (errors['gust']) {
                      <span i18n="@@wxAdmErrGust">Wind gusts: Caution must be above 0 and below Stop.</span>
                    }
                    @if (errors['rain']) {
                      <span i18n="@@wxAdmErrRain">Precipitation: Caution must be above 0 and below Stop.</span>
                    }
                    @if (errors['low']) {
                      <span i18n="@@wxAdmErrLow">Day's low: Stop must be colder than Caution, and Caution below the Caution for the day's high.</span>
                    }
                    @if (errors['high']) {
                      <span i18n="@@wxAdmErrHigh">Day's high: Caution must be below Stop.</span>
                    }
                  </div>
                }

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@wxAdmStormStop">Thunderstorm or freezing rain stops work:</div>
                  <mat-checkbox class="app-checkbox" formControlName="stormStop" />
                </div>
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n="@@wxAdmStormProb">Counts as a thunderstorm from (probability, %):</div>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <label>
                      <input type="number" class="app-input" matInput formControlName="stormProb" min="1" max="100" step="5" />
                    </label>
                  </mat-form-field>
                </div>
                <div class="app-remark" i18n="@@wxAdmHint">
                  Defaults follow the Polish construction safety rules (Dz.U. 2003 nr 47 poz. 401): no work on scaffolding or
                  mobile work platforms during a storm or in wind above 10 m/s. Gusts often run about 1.5 × the mean wind, so a
                  15 m/s gust limit is roughly 10 m/s mean wind. The day's low runs until 07:00 next morning, so a frosty night
                  after the work counts; for concrete, mortar or painting work, set the Caution for the day's low to +5 °C.
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>security</mat-icon>
                  <span i18n>Security</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable MFA:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="securityEnableMFA"
                   />
                </div>

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>MFA via SMS:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="securityMFASMS"
                   />
                </div>

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>MFA via Authenticator App:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="securityMFAAuthApp"
                   />
                </div>

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>MFA via local phone biometrics:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="securityMFAPhoneLocalBiometric"
                   />
                </div>

                <div class="flex-row space-between-baseline">
                  <div class="app-details-subtitle2" i18n>Enable biometric login:</div>
                  <mat-checkbox class="app-checkbox"
                    formControlName="securityLoginLocalBiometric"
                   />
                </div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="config-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>translate</mat-icon>
                  <span i18n>Languages</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-col center-start config-panel-body">
                <div class="app-remark" i18n>
                  Languages selected here are available for translation and are
                  remembered for the next session.
                </div>
                <mat-selection-list formControlName="languages" class="languages-list">
                  @for (lang of allLanguages; track lang.id) {
                    <mat-list-option [value]="lang.locale">
                      {{ lang.name }} ({{ lang.locale }})
                    </mat-list-option>
                  }
                </mat-selection-list>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        } @else {
          <button
            matButton="elevated"
            color="primary"
            (click)="createConfig()"
            class="app-panel-button"
            i18n
          >
            Create new config
          </button>
        }
      }
      @if (configLoaded === null) {
        <p class="app-message" i18n>No config loaded from server</p>
      }
      @if (configLoaded === false) {
        <p class="app-message" i18n>Error when loading config from server</p>
      }
    </div>
  </div>
</mat-card>
